// ABOUTME: Coordinates competing Kanban refreshes through one shared generation.
// ABOUTME: Lets only the latest refresh apply data or invalidate cached queries.
export const startKanbanRefresh = (refreshGeneration: { current: number }) => {
    const generation = refreshGeneration.current + 1;
    refreshGeneration.current = generation;

    return () => refreshGeneration.current === generation;
};
